/**
 * Times of a classification: the distance of a row from the one above it, and how a distance reads.
 *
 * The gap of a row is the difference between its time and the time of the driver classified just
 * ahead: the first row has none, being the one the others are measured against.
 */

const MS_PER_SECOND = 1_000
const MS_PER_MINUTE = 60_000

/** A distance as "+1.234", or "+1:02.345" from a minute up; null when there is nothing to show. */
export function formatGap(milliseconds)
{
  if (milliseconds === null || milliseconds === undefined) {
    return null
  }

  const sign = milliseconds < 0 ? '-' : '+'
  const absolute = Math.abs(milliseconds)
  const seconds = Math.floor(absolute / MS_PER_SECOND)
  const millis = String(absolute % MS_PER_SECOND).padStart(3, '0')

  return absolute < MS_PER_MINUTE
    ? `${sign}${seconds}.${millis}`
    : `${sign}${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}.${millis}`
}

/**
 * The distance of every row from the row before it, in the order of the list: the first row, the
 * rows without a time and the rows opening a group other than the one ahead stay `null`. `timeOf`
 * reads the milliseconds of a row; `groupOf` reads the value two rows must share for their times to
 * be comparable (e.g. the races played), and defaults to a single group.
 */
export function gapsToPrevious(rows, timeOf, groupOf = () => null)
{
  let previous = null

  return rows.map((row) => {
    const time = timeOf(row)
    const group = groupOf(row)
    const gap = time === null || time === undefined || previous === null || previous.group !== group
      ? null
      : time - previous.time

    if (time !== null && time !== undefined) {
      previous = { time, group }
    }

    return gap
  })
}
